import { createAsyncThunk } from "@reduxjs/toolkit";
import { postAddProfileImage } from "../../helpers/fakebackend_helper";


export const profile_add_imageThunk = createAsyncThunk("profile_add_imageThunk", async ({ body, token }, { rejectWithValue } ) => {
  try {
    const response = await postAddProfileImage( body,token);
    return response;
  } catch (error) {
    // Properly pass the error structure to the reducer
    return rejectWithValue({
      code: error.data?.code || error.code,
      message: error.message,
      data: error.data
    });
  }
});




